import React, { useState } from "react";

const Pagination = ({ cardsPerPage, totalCards, paginate }) => {

  const [activePage, setActivePage] = useState(1);

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(totalCards / cardsPerPage); i++) {
    pageNumbers.push(i);
  }

  const handlePageClick = (number, event) => {
    event.preventDefault();
    setActivePage(number);
    paginate(number);
  };

  return (
    <>
      <ul className="pagination">
        {pageNumbers && pageNumbers.length > 0
          ? pageNumbers.map((number) => {
            
             return (<li
                key={number}
                className={`page-item ${activePage === number ? "active" : ""}`}
              >
                <a
                  href="#"
                  className="page-link"
                  onClick={(e) => {
                    handlePageClick(number,e);
                    paginate(number);
                  }}
                >
                  {number}
                </a>
              </li>);
            })
          : null}
      </ul>
    </>
  );
};

export default Pagination;
